import { render, staticRenderFns } from "./UnitTags.vue?vue&type=template&id=c4372436"
import script from "./UnitTags.vue?vue&type=script&lang=js"
export * from "./UnitTags.vue?vue&type=script&lang=js"
import style0 from "./UnitTags.vue?vue&type=style&index=0&id=c4372436&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports